export default {
  model: {
    'role': 'Admin roles',
    'activeStorage/attachment': 'Attachment',
    'application': 'Application',
    'adminUsersRole': 'Admin accounts',
    'adminUser': 'Admin user',
    'banner': 'Banner',
    'profile': 'Profile',
    'miapay/walletHolder': 'Wallet holder',
    'storeOwner': 'Store owner',
    'event': 'Cashback',
    'merchant': 'Store',
    'agent': 'Payment account',
    'user': 'User',
    'walk/account': 'Account',
    'activeStorage/blob': 'Resource',
    'actsAsTaggableOn/tag': 'Event tags',
    'page': 'FAQ',
    'presetPage': 'FAQ',
    'staticPage': 'FAQ',
    'customPage': 'Custom page',
    'hotWord': 'Hot word',
    'miapay/fundingSource': 'Funding source',
    'withdrawalApplication': 'Withdrawals',
    'feedback': 'Feedback',
    'miapay/transactionMetaDatum': 'Transaction meta datum',
    'plutus/entry': 'Entry',
    'brand': 'Brands',
    'redPacket': 'Grab SP',
    'customListItem': 'Items',
    'pushNotificationHistory': 'Push notification history',
    'ticketEvent': 'Event',
    'ticketKind': 'Ticket',
    'ticketOrder': 'Tickets sold details',
    'ticketOrderItem': 'Ticket order item',
    'ticket': 'Attendees',
    'resetPasswordApplication': 'Reset PIN',
    'ticketRedeemBatch': 'Sync redemption history',
    'ticketRedeemItem': 'Ticket redeem item',
    'customList': 'Ad & Video space',
    'walk/hebaRewardRuleItem': 'HEBA reward rules',
    'walk/hebaParticipationRecord': 'HEBA participants',
    'walk/stepRecord': 'Step records',
    'userRequest': 'Electricity & Airtime',
    'walk/club': 'LeCLuB clubs',
    'walk/prize': 'LeCLuB Prizes',
    'walk/challenge': 'LeCLuB challenges',
    'walk/challengeParticipationRecord': 'Challenge participants',
    'link': 'Link',
    'operationRecord': 'Operation record',
    'setting': 'Setting',
  },
  'role': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    name: `Name`,
    kind: `Kind`,
    kinds: {
      super: 'Super',
      application: 'Application',
      custom: 'Custom',
    },
    customPermissions: `Custom permissions`,
  },
  'activeStorage/attachment': {
    id: `ID`,
    createdAt: `Created at`,
    signedId: `Signed`,
    contentType: `Content type`,
    filename: `Filename`,
    byteSize: `Byte size`,
    url: `Url`,
  },
  'application': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    name: `Name`,
    desc: `Desc`,
    shareDesc: `Share description`,
    shareTitle: `Share title`,
    wechatApplicationId: `Wechat application`,
    applicationAdminUsersRoleId: `Application admin users role`,
    shareImage: `Share image`,
    logo: `Logo`,
    creator: `Creator`,
    posterImage: `Poster image`,
  },
  'adminUsersRole': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    roleId: `Role`,
    adminUserId: `Admin user`,
    applicationId: `Application`,
    role: `Admin roles`,
    application: `Application`,
    adminUser: `Admin user`,
    preferences: `Preferences`,
    adminUserAttributes: `Admin user attributes`,
  },
  'adminUser': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    email: `Email`,
    name: `User name`,
    adminUsersRolesAttributes: `Admin users roles attributes`,
  },
  'banner': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    target: `Target`,
    position: `Position`,
    pagePosition: `Page position`,
    pagePositions: {
      event: 'Cashback',
    },
    kind: `Kind`,
    kinds: {
      web_link: 'Web link',
      image: 'Image',
      mp_link: 'Mini program link',
    },
    alt: `Alt`,
    image: `Image`,
  },
  'profile': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    name: `Name`,
    email: `Email`,
    phone: `Phone`,
    gender: `Gender`,
    genders: {
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
    },
    firstName: `First Name`,
    lastName: `Last Name`,
    whatsapp: `Whatsapp`,
    instagram: `Instagram`,
    avatar: `Avatar`,
  },
  'miapay/walletHolder': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    phone: `Phone`,
    profileAttributes: `Profile attributes`,
    number: `ID Number`,
    certificateFront: `Certificate front`,
    certificateBack: `Certificate back`,
    passport: `Passport`,
    cardOwnership: `Card ownership`,
    certificateExpiredDate: `Certificate expired date`,
    lockedAt: `Suspended at`,
    idType: `ID Type`,
    idTypes: {
      togolese_passport: 'Togolese Passport',
      id_card: 'ID Card',
      other_passport: 'Other Passport',
    },
    verifyType: `Verify Type`,
    verifyTypes: {
      by_agent: 'By Agent',
      by_self: 'By Self',
    },
  },
  'storeOwner': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    phone: `Phone`,
    firstName: `First name`,
    lastName: `Last name`,
    whatsapp: `Whatsapp`,
    email: `Email`,
    kind: `Kind`,
    kinds: {
      individual: 'Individual',
      retail: 'Retail',
      business: 'Business',
    },
    source: `Source`,
    sources: {
      admin_create: 'Admin create',
      sign_up: 'Sign up',
    },
    name: `Name`,
    agentStatus: `Agent status`,
  },
  'event': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    cashbackPercent: `Cashback percentage(%)`,
    cashbackStartDate: `Cashback start date`,
    cashbackEndDate: `Cashback end date`,
    cashbackInstructionFr: `Cashback description(FR)`,
    cashbackInstructionEn: `Cashback description(EN)`,
    merchantId: `Store`,
    state: `State`,
    states: {
      will_start: 'Will start',
      actived: 'Actived',
      expired: 'Expired',
    },
  },
  'merchant': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    name: `Store's name`,
    phone: `Store's phone number`,
    whatsapp: `Whatsapp`,
    instagram: `Instagram`,
    gozem: `Gozem`,
    location: `Location`,
    latitude: `Latitude`,
    longitude: `Longitude`,
    introduction: `Introduction`,
    cashbackPercent: `Cashback percentage(%)`,
    followsCount: `Follows count`,
    cashbackEndDate: `Cashback end date`,
    cashbackStartDate: `Cashback start date`,
    cashbackInstructionFr: `Cashback description(FR)`,
    cashbackInstructionEn: `Cashback description(EN)`,
    storeOwnerId: `Store owner`,
    cover: `Cover`,
    storeOwner: `Store owner`,
    showOnPlacesSection: `Show on places section`,
    showOnCatalog: `Show on catalog`,
    showOnExploreSection: `Show on explore section`,
    position: `Position`,
    tagList: `Tags`,
    exploreTagList: `Explore tag list`,
    logo: `Logo`,
    images: `Images`,
    collectQrCodeUrl: `Collect qr code url`,
  },
  'agent': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    phone: `Phone`,
    lockedAt: `Suspended at`,
    status: `Status`,
    statuses: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      actived: 'Actived',
    },
    name: `Name`,
    refCode: `Ref code`,
    storeOwnerId: `Store owner`,
    storeOwner: `Store owner`,
    merchantId: `Store`,
    merchant: `Store`,
    miapayWalletHolderAttributes: `Miapay wallet holder attributes`,
    canResetPassword: `Can reset password`,
    balance: `Balance (FCFA)`,
    cashback: `Coins (MPC)`,
  },
  'user': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    screenName: `Screen name`,
    isBlock: `Suspended`,
    phone: `Phone`,
    name: `Name`,
    verificationState: `Verification state`,
    verificationStates: {
      init: 'Unverified',
      pending: 'Pending',
      approved: 'Verified',
      rejected: 'Rejected',
    },
    verifier: `Verifier`,
    verifyAt: `Verified at`,
    number: `ID Number`,
    rejectReason: `Reject reason`,
    miapayWalletHolderAttributes: `Miapay wallet holder attributes`,
    canResetPassword: `Can reset password`,
    canUnlockRedPacketFunction: `Can unlock red packet function`,
    balance: `Balance (FCFA)`,
    cashback: `Coins (MPC)`,
    walkAccount: `Walk account`,
  },
  'walk/account': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    username: `Username`,
    joinLeclubAt: `Join leclub at`,
    lockedAt: `Suspended at`,
  },
  'activeStorage/blob': {
    id: `ID`,
    createdAt: `Created at`,
    signedId: `Signed`,
    contentType: `Content type`,
    filename: `Filename`,
    byteSize: `Byte size`,
    url: `Url`,
    tagList: `Tags`,
  },
  'actsAsTaggableOn/tag': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    name: `Name`,
    kind: `Kind`,
    kinds: {
      ticket_event: 'Event tag',
      pavillon: 'Pavillon',
      explore: 'Explore',
    },
  },
  'page': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    slug: `Slug`,
    title: `Title`,
    type: `Type`,
    applicationId: `Application`,
    status: `Status`,
    statuses: {
      draft: 'Draft',
      published: 'Published',
    },
    viewsCount: `Views count`,
    miniProgramPath: `Mini program path`,
    wxacode: `Wxacode`,
    content: `Content`,
  },
  'presetPage': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    title: `Title`,
    slug: `Slug`,
    viewsCount: `Views count`,
    content: `Content`,
  },
  'staticPage': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    title: `Title`,
    slug: `Slug`,
    status: `Status`,
    statuses: {
      draft: 'Draft',
      published: 'Published',
    },
    viewsCount: `Views count`,
    wxacode: `Wxacode`,
    content: `Content`,
  },
  'customPage': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    title: `Title`,
    slug: `Slug`,
    default: `Default`,
    miniProgramPath: `Mini program path`,
    publishedAt: `Published at`,
    formalCustomPageId: `Formal custom page`,
    formalCustomPage: `Formal custom page`,
    canRollbackData: `Can rollback data`,
    configs: `Configs`,
  },
  'hotWord': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    name: `Name`,
    position: `Position`,
    applicationId: `Application`,
    application: `Application`,
  },
  'miapay/fundingSource': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    number: `Phone number`,
    type: `Type`,
  },
  'withdrawalApplication': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    amountCents: `Amount (FCFA)`,
    channel: `Channel`,
    number: `ID Number`,
    receivableAccountType: `Receivable account type`,
    auditorId: `Auditor`,
    receivableAccountId: `Receivable account`,
    state: `State`,
    states: {
      init: 'Init',
      completed: 'Completed',
      rejected: 'Rejected',
    },
    walletHolderId: `Wallet holder`,
    finishedAt: `Finished at`,
    rejectReason: `Reject reason`,
    auditor: `Auditor`,
  },
  'feedback': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    phone: `Phone`,
    creator: `Creator`,
    description: `Description`,
    isResolve: `Resolved`,
    solver: `Solver`,
    images: `Images`,
  },
  'miapay/transactionMetaDatum': {
    id: `ID`,
    createdAt: `Transaction at`,
    updatedAt: `Updated at`,
    number: `Transaction ID`,
    amountCents: `Amount (FCFA)`,
    state: `State`,
    states: {
      init: 'Init',
      completed: 'Completed',
      failed: 'Failed',
      canceled: 'Canceled',
    },
    finishedAt: `Finished at`,
    kind: `Kind`,
    kinds: {
      topup: 'Topup',
      withdraw: 'Withdraw',
      transfer: 'Transfer',
      pay_with_qr_code: 'Pay with qr code',
      cashback: 'Coins (MPC)',
      create_red_packet: 'Create red packet',
      receive_red_packet: 'Receive red packet',
      red_packet_expire: 'Red packet expire',
      order_ticket: 'Order ticket',
      electricity: 'Electricity',
      airtime: 'Airtime',
      join_challenge: 'Join challenge',
    },
    creditorType: `Creditor type`,
    debitorType: `Debitor type`,
    cashbackAmountCents: `Coins (MPC)`,
    remark: `Remark`,
    data: `Data`,
    creditorNumber: `Creditor number`,
    debitorNumber: `Debitor number`,
    creditorMiapayWalletHolder: `Creditor miapay wallet holder`,
    debitorMiapayWalletHolder: `Debitor miapay wallet holder`,
  },
  'plutus/entry': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    commercialDocumentType: `Commercial document type`,
    commercialDocumentId: `Commercial document`,
    date: `Date`,
    description: `Description`,
  },
  'brand': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    name: `Name`,
    logo: `Logo`,
    poster: `Poster`,
  },
  'redPacket': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    code: `Code`,
    type: `Type`,
    totalAmount: `Total amount`,
    quantity: `Quantity`,
    state: `State`,
    states: {
      init: 'Init',
      actived: 'Actived',
      completed: 'Completed',
      expired: 'Expired',
    },
    expiredAt: `Expired at`,
    kind: `Kind`,
    kinds: {
      cash: 'Cash (FCFA)',
      cashback: 'Coins (MPC)',
    },
    limitOnePersonTotalReceiveCount: `Limit total receive count per person`,
    limitOnePersonReceiveCountPerDay: `Limit one person receive count per day`,
    remainingAmount: `Remaining amount`,
    qrcode: `QR Code`,
    brandId: `Brand`,
    brand: `Brands`,
    receivedCount: `Received count`,
    receivedAmount: `Received amount (FCFA)`,
    user: `User`,
    customListItemAttributes: `Custom list item attributes`,
  },
  'customListItem': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    targetType: `Target type`,
    targetId: `Target`,
    position: `Position`,
    externalLink: `External link`,
    image: `Image`,
    video: `Video`,
    videoCover: `Video cover`,
    target: `Target`,
  },
  'pushNotificationHistory': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    phones: `Phones`,
    creatorId: `Creator`,
    kind: `Kind`,
    kinds: {
      sms: 'Sms push',
      client: 'Client app push',
      agent: 'Merchant app push',
    },
    readCount: `Read count`,
    sentCount: `Sent count`,
    allUsers: `All users/agents`,
    openRates: `Open rates`,
    messages: `Messages`,
    creator: `Creator`,
  },
  'ticketEvent': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    title: `Title`,
    address1: `Address1`,
    address2: `Address2`,
    businessHours: `Business hours`,
    location: `Location`,
    isShow: `Is show`,
    endAt: `End at`,
    startAt: `Start at`,
    serialCode: `Serial code`,
    tagList: `Tags`,
    cover: `Cover`,
    introduction: `Introduction`,
    faq: `FAQ`,
    posters: `Posters`,
  },
  'ticketKind': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    ticketEventId: `Event`,
    title: `Title`,
    capacity: `Capacity`,
    priceCents: `Price (FCFA)`,
    description: `Description`,
    activityTimeKind: `Activity time kind`,
    activityTimeKinds: {
      exact_date: 'Exact date',
      day_of_week: 'Day of week',
    },
    startDayOfWeek: `Start day of week`,
    endDayOfWeek: `End day of week`,
    startDate: `Start date`,
    endDate: `End date`,
    expirationKind: `Expiration kind`,
    expirationKinds: {
      base_on_event: 'Base on event end time',
      custom: 'Custom expiration time',
    },
    expireAt: `Expired at`,
    ticketEvent: `Event`,
    soldCapacity: `Sold quantity`,
    soldAmount: `Total amount (FCFA)`,
  },
  'ticketOrder': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    number: `ID Number`,
    amountCents: `Amount (FCFA)`,
    state: `State`,
    states: {
      pending: 'Not paid',
      paid: 'Paid',
    },
    user: `User`,
    creator: `Creator`,
    ticketEventId: `Event`,
    ticketEvent: `Event`,
    paidAt: `Paid at`,
    ticketNumberStartAt: `Start ticket number`,
    ticketOrderItems: `Items`,
    ticketExportStatus: `Export qrcode status`,
    ticketExportStatuses: {
      init: 'Init',
      pending: 'Pending',
      progressing: 'In progress',
      completed: 'Completed',
    },
    exportTicketsFile: `Export qrcode link`,
  },
  'ticketOrderItem': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    priceCents: `Price (FCFA)`,
    quantity: `Quantity`,
    ticketKind: `Ticket`,
    ticketOrder: `Tickets sold details`,
  },
  'ticket': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    serialCode: `Serial code`,
    expireAt: `Expired at`,
    redeemAt: `Redeem at`,
    user: `User`,
    ticketEvent: `Event`,
    ticketKind: `Ticket`,
    redeemer: `Redeemer`,
    ticketOrder: `Tickets sold details`,
  },
  'resetPasswordApplication': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    rejectReason: `Reject reason`,
    idType: `ID Type`,
    idTypes: {
      togolese_passport: 'Togolese Passport',
      id_card: 'ID Card',
      other_passport: 'Other Passport',
    },
    state: `State`,
    states: {
      init: 'Init',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    miapayWalletHolder: `Miapay wallet holder`,
    certificateBack: `Certificate back`,
    certificateFront: `Certificate front`,
    passport: `Passport`,
    auditor: `Auditor`,
  },
  'ticketRedeemBatch': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    redeemerId: `Redeemer`,
    ticketEventId: `Event`,
    redeemer: `Redeemer`,
    ticketEvent: `Event`,
    ticketRedeemItems: `Items`,
  },
  'ticketRedeemItem': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    errorMessage: `Error message`,
    updateStatus: `Sync status`,
    updateStatuses: {
      init: 'Init',
      success: 'Success',
      failed: 'Failed',
    },
    redeemAt: `Redeem at`,
    ticket: `Attendees`,
    ticketSerialCode: `Ticket serial code`,
  },
  'customList': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    code: `Code`,
    name: `Name`,
    kind: `Kind`,
    kinds: {
      merchant_list: 'Store list',
      list_with_image: 'List with image',
      video_list: 'List with video',
      image: 'One image',
    },
    isActive: `Turn on`,
    customListItemsAttributes: `Custom list items attributes`,
  },
  'walk/hebaRewardRuleItem': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    cashback: `Coins (MPC)`,
    target: `Target (Km)`,
  },
  'walk/hebaParticipationRecord': {
    id: `ID`,
    createdAt: `Joined at`,
    updatedAt: `Updated at`,
    month: `Month`,
    target: `Target`,
    healthPoints: `Health points`,
    rewardState: `Reward state`,
    rewardStates: {
      init: 'Init',
      pending: 'Pending',
      received: 'Received',
    },
    state: `State`,
    states: {
      pending: 'Ongoing',
      completed: 'Completed',
      failed: 'Incomplete',
    },
    rewardCashback: `Reward coins (MPC)`,
    miapayWalletHolder: `Miapay wallet holder`,
    stepByMonth: `Steps (after joined)`,
    kilometersDistanceByMonth: `Distance (Km)`,
  },
  'walk/stepRecord': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    date: `Date`,
    step: `Steps`,
    deviceId: `Device ID`,
    isActive: `Actived`,
    miapayWalletHolder: `Miapay wallet holder`,
    errorMessage: `Error message`,
    errorMessageCode: `Error message code`,
    errorMessageCodes: {
      only_first_wallet_holder_of_the_same_device_is_active: 'Only first wallet holder of the same device is active',
      only_highest_step_on_the_same_date_is_active: 'Only highest step on the same date is active',
      walk_account_locked: 'Walk account locked',
    },
    firstWalletHolderOfTheSameDevice: `First wallet holder of the same device`,
  },
  'userRequest': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    number: `ID Number`,
    remark: `Remark`,
    type: `Type`,
    amountCents: `Amount (FCFA)`,
    state: `State`,
    states: {
      pending: 'Pending',
      paid: 'Paid',
    },
    userId: `User`,
    user: `User`,
  },
  'walk/club': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    name: `Name`,
    creatorType: `Creator type`,
    creatorId: `Creator`,
    creator: `Creator`,
    logo: `Logo`,
    introduction: `Introduction`,
    detailImage: `Detail image`,
  },
  'walk/prize': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    title: `Title`,
    introduction: `Introduction`,
    covers: `Covers`,
    images: `Images`,
  },
  'walk/challenge': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    amountCurrency: `Amount currency`,
    subTitle: `Subtitle`,
    title: `Title`,
    amountCents: `Amount (FCFA)`,
    target: `Target (Km)`,
    walkClubId: `LeCLuB club`,
    walkPrizeId: `LeCLuB prize`,
    winnersCount: `Winners count`,
    endDate: `End date`,
    startDate: `Start date`,
    prizeDesc: `Prize description`,
    walkClub: `LeCLuB clubs`,
    walkPrize: `LeCLuB Prizes`,
    isStarted: `Started`,
    isEnded: `Ended`,
    introduction: `Introduction`,
    cover: `Cover`,
    detailImage: `Detail image`,
  },
  'walk/challengeParticipationRecord': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    amountCurrency: `Amount currency`,
    amountCents: `Amount (FCFA)`,
    miapayWalletHolderId: `Miapay wallet holder`,
    rewardState: `Reward state`,
    rewardStates: {
      init: 'Init',
      pending: 'Pending',
      requested: 'Requested',
      sent: 'Sent',
      failed: 'Rank not reached',
    },
    state: `Challenge status`,
    states: {
      pending: 'Not paid',
      paid: 'Ongoing',
      completed: 'Completed',
      failed: 'Incomplete',
    },
    totalStep: `Steps (after joined)`,
    walkChallengeId: `LeCLuB challenge`,
    paidAt: `Paid at`,
    totalKilometersDistance: `Distance (Km)`,
    rank: `Rank`,
    miapayWalletHolder: `Miapay wallet holder`,
    walkChallenge: `LeCLuB challenges`,
    phone: `Phone`,
    fullName: `Full name`,
  },
  'link': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    type: `Type`,
    url: `Url`,
  },
  'operationRecord': {
    id: `ID`,
    createdAt: `Created at`,
    updatedAt: `Updated at`,
    content: `Content`,
    contentEn: `Content en`,
    adminUser: `Admin user`,
    previousObject: `Previous object`,
    currentObject: `Current object`,
  },
  'setting': {
  },
}
